import { render } from "./login-dingtalk1.html?vue&type=template&id=ce252142&scoped=true&ts=true"
import script from "./login-dingtalk1.ts?vue&type=script&lang=ts"
export * from "./login-dingtalk1.ts?vue&type=script&lang=ts"

import "./login-dingtalk1.scss?vue&type=style&index=0&id=ce252142&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce252142"]])

export default __exports__